import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SplitModuleIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SplitModule",
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.82 2.01h2.35c.45 0 .82.37.82.82v2.35c0 .45-.37.82-.82.82h-2.35c-.45 0-.82-.37-.82-.82V2.83c0-.45.37-.82.82-.82m0 23.99h2.35c.45 0 .82.37.82.82v2.35c0 .45-.37.82-.82.82h-2.35c-.45 0-.82-.37-.82-.82v-2.35c0-.45.37-.82.82-.82M28.81 8.01H18v1.17c0 .45-.37.82-.82.82h-2.35c-.45 0-.82-.37-.82-.82V8.01H3.19C2.53 8.01 2 8.54 2 9.2v13.61c0 .66.53 1.19 1.19 1.19H14v-1.22c0-.45.37-.82.82-.82h2.34c.45 0 .82.37.82.82v1.18H28.8c.65 0 1.18-.53 1.19-1.18V9.2c0-.66-.53-1.19-1.19-1.19ZM18 17.18c0 .45-.37.82-.82.82h-2.35c-.45 0-.82-.37-.82-.82v-2.34c0-.45.37-.82.82-.82h2.35c.45 0 .82.37.82.82z"
    })
  }));
};